import YaCounter from "../analytics/ym";
import GoogleAnalytics from "../analytics/ga";

window.VegasCatalog.Cart = {
	add: function (id, cnt, params, callback) {
		params = params || {};
		params.id = id;
		params.cnt = cnt || 1;
		params._token = App.csrf;

		this.addRequest(params, callback);
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);

			new YaCounter().goal('add-to-cart');
			new GoogleAnalytics().goal('Addtocart');

			VegasCatalog.popup('Добавлено в корзину');
		});
	},

	tmChangeCount: null,
	changeCnt: function (id, cnt, appendParams, callback) {
		clearTimeout(this.tmChangeCount);
		this.tmChangeCount = setTimeout(() => {
			let params = appendParams || {};
			params.id = id;
			params.cnt = cnt;
			params = VegasCatalog.Cart.formData(params);

			$formCart.find('.totals-area').addClass('loading');

			$.post('/cart/change_product', params, function (data) {
				if (typeof callback === 'function')
					callback(data);

				VegasCatalog.Cart.total(data);

				$formCart.find('.totals-area').removeClass('loading');
			});
		}, 200);
	},

	remove: function (id, callback) {
		let params = {};
		params.id = id;
		params._token = App.csrf;

		this.removeRequest(params, callback);
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Убрано из корзины');
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter=products]').attr('data-cnt', data.products_count);
			$('[data-sum=products] [data-word=products]').text(output_wordform(data.products_count, [
				'товар', 'товара', 'товаров'
			]));
		}

		this.totalCartForm(data);
		this.totalCartProducts(data);

		$formCart.find('.totals-area').removeClass('loading');
	},

	totalCartForm: function (data) {
		let $form = $('#form-cart');

		if ($form.length) {
			let $totalsArea = $form.find('.totals-area');

			if (data.sums.sum > 0) {
				$totalsArea.removeClass('d-none');
			} else {
				$totalsArea.addClass('d-none');
			}

			// products sum
			let $sProducts = $form.find('[data-sum="products"]');
			if (data.sums.sum_products > 0) {
				$sProducts.find('[data-sum-value]').text(output_money(data.sums.sum_products));
			} else {
				$sProducts.find('[data-sum-value]').text('-');
			}

			// user discount sum
			let $sUserDiscountSum = $form.find('[data-sum="user_discount"]');
			if (data.sums.sum_user_discount > 0) {
				$sUserDiscountSum.find('[data-sum-value]').text(output_money(data.sums.sum_user_discount));
				$sUserDiscountSum.show();
			} else {
				$sUserDiscountSum.hide();
			}
			// cart sum
			let $sCart = $form.find('[data-sum="total"]');
			$sCart.find('[data-sum-value]').text(output_money(data.sums.sum));

			// delivery sym
			let $sDelivery = $form.find('[data-sum="delivery"]');
			if (data.sums.sum_delivery !== null) {
				if (!isNaN(data.sums.sum_delivery)) {
					$sDelivery.find('[data-sum-value]').text(data.sums.sum_delivery > 0 ? output_money(data.sums.sum_delivery) : 'бесплатно');
					if (data.sums.sum_delivery > 0) {
						$sDelivery.find('.msg').show();
					} else {
						$sDelivery.find('.msg').hide();
					}
				} else {
					$sDelivery.find('[data-sum-value]').text(data.sums.sum_delivery);
					$sDelivery.find('.msg').hide();
				}

				$sDelivery.show();
			} else {
				$sDelivery.hide();
			}
		}
	},

	totalCartProducts: function (data) {
		let $cartProducts = $('.catalog-cart--products');
		if ($cartProducts.length && typeof data.products_totals !== 'undefined') {
			for (let i in data.products_totals) {
				let p = data.products_totals[i];

				$cartProducts.find('[data-product-cart-item][data-pivot_id="' + p.pivot_id + '"]')
					.find('.price-total')
					.text(output_money(p.price_total));
			}
		}
	},

	updateTotalAll: function () {
		$formCart.find('.totals-area').addClass('loading');
		$.get('/cart/get_totals', VegasCatalog.Cart.formData(), function (data) {
			VegasCatalog.Cart.total(data);
		});
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = $('#form-cart').serializeArray();

		if (!resultParams.length) {
			resultParams.push({name: '_token', value: App.csrf});
		}

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		return resultParams;
	},
};

let $document = $(document),
	$formCart = $("#form-cart")
;

$(document).ready(function () {
	if ($formCart.length) {
		VegasCatalog.Cart.updateTotalAll();
	}

	/** PRODUCT LIST **/
	$document.on('click', '[data-product-item].grid [data-cart][data-action=add]', function () {
		let $product = $(this).closest('[data-product-item]');
		let $btn = $(this);
		let id = $product.data('id');

		if ($product.hasClass('in-cart')) {
			location.href = '/cart';
			return false;
		}

		$product.addClass('in-cart');
		$btn.html('<i class="fal fa-arrow-right small"></i> В корзине');

		VegasCatalog.Cart.add(id);

		return false;
	});

	/** PRODUCT LIST COMPACT **/
	$document.on('click', '[data-product-item].compact [data-cart][data-action=add]', function () {
		let $product = $(this).closest('[data-product-item]');
		let $btn = $(this);
		let id = $product.data('id');

		$product.addClass('in-cart');
		$btn.html('Убрать');
		$btn.attr('data-action', 'del');

		VegasCatalog.Cart.add(id);

		return false;
	});

	/** PRODUCT OFFER **/
	$document.on('click', '[data-product-offer-item] [data-cart][data-action=add]', function () {
		let $product = $(this).closest('[data-product-offer-item]');
		let $btn = $(this);
		let id = $product.data('id');

		if ($product.hasClass('in-cart')) {
			location.href = '/cart';
			return false;
		}

		$product.addClass('in-cart');
		$btn.html('<i class="fal fa-arrow-right small"></i> В корзине');

		VegasCatalog.Cart.add(id);

		return false;
	});

	$document.on('click', '[data-product-item].compact [data-cart][data-action=del]', function () {
		let $product = $(this).closest('[data-product-item]');
		let $btn = $(this);
		let id = $product.data('id');

		$product.removeClass('in-cart');

		$btn.attr('data-action', 'add').html('<i class="fa fa-cart-shopping"></i>');

		VegasCatalog.Cart.remove(id);

		return false;
	});

	/** PRODUCT SHOW **/
	$document.on('click', '[data-product] [data-cart][data-action=add]', function () {
		let $product = $(this).closest('[data-product]');
		let $btn = $(this);
		let id = $product.data('id');

		if ($product.hasClass('in-cart')) {
			location.href = '/cart';
			return false;
		}

		$product.addClass('in-cart');
		$btn.html('<i class="fal fa-arrow-right small"></i> В корзине');

		VegasCatalog.Cart.add(id, 1, {
			options: (() => {
				let options = $product.find('.form-options').serializeArray();
				let result = Array.from(options).map((v) => v.value);

				return result;
			})()
		});

		return false;
	});
	$document.on('click', '[data-product] [href="#modal-one-click"]', function () {
		let $product = $(this).closest('[data-product]');

		let options = $product.find('.form-options').serializeArray();
		let optionsValues = Array.from(options).map((v) => v.value);
		let optionsJson = JSON.stringify(optionsValues);

		$("#modal-one-click").find('[name="options"]').val(optionsJson);

		return false;
	});

	/*$document.on('click', '[data-product] [data-cart][data-action=del]', function () {
		let $product = $(this).closest('[data-product]'),
			$btn = $(this),
			id = $product.data('id');

		stateCatalogElement($product, $btn, 'del', stateAdditionalCart);

		VegasCatalog.Cart.remove(id);

		return false;
	});*/

	/*$document.on('change-counter', '[data-product] [data-cart="qty"]', function () {
		let $product = $(this).closest('[data-product]');
		let id = $product.data('id');

		let cnt = $(this).find('input[type=number]').val();
		VegasCatalog.Cart.changeCnt(id, cnt);

		return false;
	});*/

	/*$document.on('click', '[data-product] [data-qty=trash]', function () {
		let $product = $(this).closest('[data-product]');
		let id = $product.data('id');

		$product.removeClass('in-cart');
		VegasCatalog.Cart.remove(id);

		return false;
	});*/

	/** PRODUCT CART ITEM */
	$document.on('change-counter', '[data-product-cart-item] [data-cart="qty"]', function () {
		let $product = $(this).closest('[data-product-cart-item]');
		let pivot_id = $product.data('pivot_id');

		let cnt = $(this).find('input[type=number]').val();
		VegasCatalog.Cart.changeCnt(0, cnt, {
			pivot_id: pivot_id,
			get_products_totals: true
		});

		return false;
	});

	$document.on('click', '[data-product-cart-item] [data-cart][data-action="del"]', function () {
		let $product = $(this).closest('[data-product-cart-item]');
		let id = $product.data('id');
		let $list = $product.closest('.catalog-cart--products');

		$product.remove();

		if ($list.hasClass('invalid') && $list.find('[data-product-cart-item]').length === 0) {
			$list.remove();
		}

		VegasCatalog.Cart.remove(id, function () {
			let cnt = $list.find('[data-product-cart-item]').length;

			if (!$list.hasClass('invalid') && !cnt) {
				location.reload();
			}

			VegasCatalog.Cart.updateTotalAll();
		});

		return false;
	});
});

require('./_cart_delivery.js')
